export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '9155d167-ae2f-4b35-bfc6-8cc01c9d6a0b';
export const MODAL_CLOSE_SEC = 2.5;
